import Vue from 'vue'
import Router from 'vue-router'

import { Message } from 'element-ui'
import VDistpicker from 'v-distpicker'

Vue.component('v-distpicker', VDistpicker)

const HelloWorld = () => import('../components/HelloWorld.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js